<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22">
    <defs></defs>
    <g id="Layer_2" data-name="Layer 2">
      <g id="Layer_1-2" data-name="Layer 1">
        <g id="Group_1253" data-name="Group 1253">
          <path
            id="Path_501"
            data-name="Path 501"
            class="cls-1"
            d="M22,11h0A11,11,0,0,0,0,11H0a11,11,0,0,0,22,0Z"
          />
          <g id="Group_1252" data-name="Group 1252">
            <path
              id="Path_502"
              data-name="Path 502"
              class="cls-2"
              d="M5.82,9.73a.37.37,0,0,1,0-.53h0l.61-.61a.37.37,0,0,1,.53,0l3.71,3.68,3.72-3.68a.37.37,0,0,1,.53,0l.61.61a.37.37,0,0,1,0,.53l-4.59,4.56a.39.39,0,0,1-.53,0h0Z"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {};
</script>

<style scoped>
.cls-1 {
  fill: #0064ff;
}
.cls-2 {
  fill: #fff;
}
</style>
